import '~/common/styles/styles.css';
import { App } from '~/app/App';

export default App;
